const trimObject = obj => {
  Object.keys(obj).map(
    k => (obj[k] = typeof obj[k] == 'string' ? obj[k].trim() : obj[k]),
  );
  return obj;
};

export default trimObject;
